import accountVerifyMixin from '@/mixins/accountVerify';

export default {
  mixins: [
    accountVerifyMixin
  ],
  methods: {
    onGoToWallet() {
      if (this.isUserVerified) {
        this.$router.push({ name: 'wallet' });
      } else {
        this.$router.push({ name: 'account-details' });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/add-funds-combined/footer/footer.js